import * as React from 'react';
import './stylesheets/Loading.css';

const LoadingCircleIcon: React.FC = function () {
  return <img className="Loading-circle" alt="Loading" src="/circle.png" />;
};

interface LoadingProps {
  open?: boolean;
}

/**
 * 読み込み中の覆いを表示する。
 * 本文の領域（.App-main）の中に置かれたときは本文の領域だけを覆い、
 * ログイン前など本文の領域の外に置かれたときは画面全体を覆う（Loading.css）。
 */
export const Loading: React.FC<LoadingProps> = function (props) {
  if (props.open !== undefined && !props.open) {
    return <div></div>;
  }
  return (
    <div className="Loading-background" role="status" aria-label="読み込み中">
      <div className="Loading-indicator">
        <LoadingCircleIcon />
        <LoadingCircleIcon />
        <LoadingCircleIcon />
      </div>
    </div>
  );
};
